<h3>{{ mapData.carPark.name }}</h3>
<app-map-view
  [title]="mapData.carPark.name"
  bgColor="#33766f"
  [center]="geolocation"
  [pins]="pins"
  [zoom]="zoom"
  [height]="height"
  (closeMapView)="onCloseMapView()"
></app-map-view>
